export enum TabType {
  ADMIN,
  ERT,
  ACTIVE,
  INACTIVE
}

export enum ColorCode {
  PENDING_APPROVAL = '#FF7D23',
  REVOKE_RIGHTS = '#01539A',
  ROLE_DEACTIVATED = '#8b8b8b',
  ROLE_BLOCKED = '#FC545C',
  ROLE_TITLE = '#008266'
}
